// removed by extract-text-webpack-plugin
module.exports = {"ad":"styles__ad___1O99x","adLabel":"styles__adLabel___2p_Qf"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/ad/styles.css
// module id = Fi1p
// module chunks = 2